import { CaretDownIcon } from "@octopusdeploy/design-system-icons";
import * as React from "react";
export function DropDownIcon() {
    return <CaretDownIcon size={24}/>;
}
